import React from 'react';

import { H2, H4 } from 'primitives/appTitle';
import AppSection from 'primitives/appSection';
import { FormikProps } from 'formik';

import { PhotographerApplicationDTO } from 'appAPITypes';

import { MaterialPhotoSection } from './materialPhoto';
import { MaterialInfos } from './materialInfos';
import { MaterialVideoSection } from './materialVideo';
import { MaterialMatterportSection } from './materialMatterport';
import { MaterialDroneSection } from './materialDrone';
import { ShText } from '@shoootin/translations';
import { JoinPageTranslations } from '../joinPageTranslations';

export const MaterialSection = ({
  form,
}: {
  form: FormikProps<PhotographerApplicationDTO>;
}) => {
  return (
    <AppSection
      className="photograph-gear left"
      header={
        <H2>
          <ShText message={JoinPageTranslations.materialTitle} />
        </H2>
      }
    >
      <MaterialInfos />

      <H4>
        <ShText message={JoinPageTranslations.materialSubtitle} />
      </H4>
      <MaterialPhotoSection form={form} />
      <MaterialVideoSection form={form} />
      <MaterialMatterportSection form={form} />
      <MaterialDroneSection form={form} />
    </AppSection>
  );
};
